"use strict";

exports.__esModule = true;
var _OpenDashboardActionElement = require("./OpenDashboardActionElement");
Object.keys(_OpenDashboardActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OpenDashboardActionElement[key]) return;
  exports[key] = _OpenDashboardActionElement[key];
});
var _OpenDashboardActionFields = require("./OpenDashboardActionFields");
Object.keys(_OpenDashboardActionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OpenDashboardActionFields[key]) return;
  exports[key] = _OpenDashboardActionFields[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});